import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getSiteList(params) {
  return request({
    url: URL.partner.site,
    method: 'get',
    params
  })
}

export function saveSite(data) {
  return request({
    url: URL.partner.site,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function saveDoorSite(data) {
  return request({
    url: URL.partner.saveSite,
    method: 'post',
    data
  })
}

export function delSite(uuid) {
  return request({
    url: URL.partner.site + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
